import Address from "@/classes/global/Address";
import ContactDetail from "@/classes/bookings/ContactDetail";
import GridColumn from "@/classes/component-classes/GridColumn";
import DropDownItem from "@/classes/component-classes/DropDownItem";
import ValidatedField from "@/classes/global/ValidatedField";
import QuoteModel from "@/classes/quote/QuoteModel";
import QuotePortSelections from "@/classes/quote/QuotePortSelections";

export default class Quote {

    constructor() {

        this.model = new QuoteModel();

        this.unitOfMeasureSwitch = false;

        this.openDocsDrawer = false;
        this.browseQuoteSearchResults = [];
        this.currentBrowsePage = 1;
        this.paginationRange = 1
        this.chargeDescriptionsData = [];
        this.chargesTotal = 0;
        this.jobAccepted = false;
        this.shipmentDocs = []; // named for re use of booking components

        this.portSelections = new QuotePortSelections();

        this.browseQuoteSearchCriteria = {

            quoteReference: '',
            customerReference: '',
            airport: '',
            quoteDate: ''
        }

        this.browseQuoteSearchPills = {

            quoteRef: {
                enabled: true,
                history: []
            },

            customerRef: {
                enabled: true,
                history: []
            },

            destination: {
                enabled: true,
                history: []
            },

            quoteDate: {
                enabled: true,
            }

        }

        this.metaData = {

            countries: [],
            packagingTypes: [],
            currencies: [],
            terms: []
        }

        this.validatedFields = [

            // new ValidatedField('quoteType', true, true, 'QuoteType'),
            // new ValidatedField('transportMode', true, false, 'Mode'),
            // new ValidatedField('origin', true, true, 'Origin'),
            // new ValidatedField('destination', true, true, 'Destination'),
            // new ValidatedField('originPort', true, false, 'Origin Port'),
            // new ValidatedField('destinationPort', true, false, 'Destination Port'),
            // new ValidatedField('movementDate', true, false, 'Collect By'),
            // new ValidatedField('deliveryDate', true, false, 'Deliver By'),
            // new ValidatedField('customerRef', true, false, 'Customer Ref'),
            // new ValidatedField('commodity', true, false, 'Goods Description'),
            // new ValidatedField('valueCurrency', true, false, 'Currency'),
            // new ValidatedField('value', true, false, 'Value'),
            // new ValidatedField('hazardClass', true, false, 'Hazard Class'),
        ]

        this.hazardClasses = [

            new DropDownItem('1', '1 - Explosives'),
            new DropDownItem('2', '2 - Gases'),
            new DropDownItem('2.1', '2.1 - Flammable Gas'),
            new DropDownItem('2.2', '2.2 - Non-Flammable, Non-Toxic Gas'),
            new DropDownItem('2.3', '2.3 - Toxic Gas'),
            new DropDownItem('3', '3 - Flammable Gas'),
            new DropDownItem('4', '4 - Flammable Solids'),
            new DropDownItem('4.1', '4.1 - Flammable Solid'),
            new DropDownItem('4.2', '4.2 - Spontaneously Combustable Substance'),
            new DropDownItem('4.3', '4.3 - Substance Which In Contact With Water Emits Flammable Gas'),
            new DropDownItem('5', '5 - Oxidising Substances'),
            new DropDownItem('5.1', '5.1 - Oxidising Substance'),
            new DropDownItem('5.2', '5.2 Organic Peroxide'),
            new DropDownItem('6.1', '6.1 - Toxic Substances'),
            new DropDownItem('6.2', '6.2 - Infectious Substance'),
            new DropDownItem('7', '7 - Radioactive Material'),
            new DropDownItem('8', '8 - Corrosive Substances'),
            new DropDownItem('9', '9 - Miscellaneous'),

        ]

        this.quoteTerms = {

            exw: false,
            cip: false,
            cpt: false,
            dap: false,
            fca: false,
            dat: false,
            ddp: false
        }

        this.quoteTypes = [

            new DropDownItem('1', 'Cross Trade'),
            new DropDownItem('2', 'Domestic'),
            new DropDownItem('3', 'Export'),
            new DropDownItem('4', 'Import'),
            new DropDownItem('5', 'Sea-Road'),
            new DropDownItem('6', 'Special')
        ]

        this.modes = [

            new DropDownItem('1', 'Air'),
            new DropDownItem('2', 'Sea'),
            new DropDownItem('3', 'Road'),
            new DropDownItem('4', 'Rail'),
            new DropDownItem('5', 'Courier'),
            new DropDownItem('6', 'Other')
        ]

        this.chargeDescriptionsColumns = [

            new GridColumn('1', 'Charge Description', 'description','300', true, false),
            new GridColumn('1', 'Currency', 'chargeCurrency','100', true, false),
            new GridColumn('1', 'Charge', 'charge','200', true, false),
            new GridColumn('1', 'Comments', 'secondDescription','460', true, false),
        ]

        this.quoteBrowseColumns = [

            new GridColumn('7', '', 'editQuote','60', true, true),
            new GridColumn('1', 'Quote Ref', 'quoteReference','255', true, false),
            new GridColumn('2', 'Customer Ref', 'customerReference','260', true, false),
            new GridColumn('3', 'Destination', 'airport','340', true, false),
            new GridColumn('4', 'Quote Date', 'quoteDate','80', true, false),
            new GridColumn('5', 'NOP', 'nop','50', true, false),
            new GridColumn('6', 'Weight', 'actualWeight','90', true, false),
            new GridColumn('6', 'Charges Applied', 'totalCharges','40', true, false),
            new GridColumn('6', 'Quote Accepted', 'jobAccepted','50', true, false),
        ]


    }
}